<template>
  <div
    :class="{
      'f-nav-wrapper': true,
      'f-nav-main': main,
      'f-nav-small': small,
    }">
    <nav
      :class="{
        'wrapper': !small,
        'flex': true,
        'flex-align-items-center': true
      }">
      <button
        id="mobile-menu-toggle"
        @click.prevent="handleToggleMenu()"
        :class="{'mobile-menu-toggle': true, 'is-open': mobileMenuVisible}">
        <span>{{ $t('ui.menu') }}</span>
      </button>
      <ul
        :class="{
          'f-nav-list flex mr-auto': true,
          'is-open': mobileMenuVisible
        }">
        <li
          v-for="(item, navItemIdx) in filteredItems"
          :key="navItemIdx"
          class="f-nav-list-item">
          <router-link
            :class="{
              'lnk': true,
              'f-nav-link': true,
              'is-completed': item.completed === true,
              'is-not-completed': item.completed === false,
              'text-danger': item.danger
            }"
            :data-counter="item.counter"
            :to="item.to"
            @click.native="handleToggleMenu()">
            <span
              v-if="item.title"
              :class="{
                'title': true,
                'hidden-mobile': item.titleMobile
              }">
              {{ item.title }}
            </span>
            <span v-if="item.titleMobile" class="title hidden-desktop-only">{{ item.titleMobile }}</span>
            <span
              v-if="item.showCounter"
              :class="{
                'counter': true,
                'counter-danger': item.messagesNotRead
              }">
              {{ item.counter }}
            </span>
          </router-link>
        </li>
      </ul>
      <slot/>
    </nav>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  name: 'f-nav',
  props: {
    items: {
      type: Array,
      required: true,
    },
    main: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    filteredItems () {
      let filteredItems = this.items.filter(item => this.$store.state.user.permissions && (this.$store.state.user.permissions[item.permissions] || !item.permissions));

      if (!this.$http.defaults.isMobileApp) {
        filteredItems = filteredItems.filter(item => !('isMobileAppOnly' in item) || !item.isMobileAppOnly);
      }
      return filteredItems;
    }
  },
  data() {
    return {
      mobileMenuVisible: false
    };
  },
  methods: {
    updateItemCounter (index, count, messagesNotRead = false) {
      Vue.set(this.items[index], 'counter', count);
      Vue.set(this.items[index], 'messagesNotRead', messagesNotRead);
    },
    handleToggleMenu () {
      if ((window.matchMedia('screen and (max-width: 1024px)')).matches) {
        Vue.set(this, 'mobileMenuVisible', !this.mobileMenuVisible);
        if (this.mobileMenuVisible) {
          document.body.classList.add('no-scroll');
          return;
        }
        document.body.classList.remove('no-scroll');
      }
    }
  }
}
</script>
